import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Common.css";
import { api } from "../API/Api.js";

/* ── Custom SVGs for Login Page ── */
const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
);
const LockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
);
const AlertCircleIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
);

const Login = () => {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Quick local validation
    if (!mobileNumber.trim()) {
      setError("Mobile Number is required");
      return;
    }
    if (!password.trim()) {
      setError("Password is required");
      return;
    }

    setIsLoading(true);

    try {
      // Connect to the ASP.NET Web API endpoint using the professional Axios instance
      const response = await api.post("/Auth/login", {
        mobileNumber: mobileNumber.trim(),
        password: password
      });

      const responseData = response.data;

      // Save user details to sessionStorage to establish session
      sessionStorage.setItem("token", responseData.token);
      sessionStorage.setItem("accountId", responseData.accountId);
      sessionStorage.setItem("mobileNumber", responseData.mobileNumber);

      // Redirect successfully to dashboard!
      navigate("/userdashboard");

    } catch (err) {
      console.error("Login API connection error:", err);

      // Extract error message from response if available
      let errorMessage = "Failed to connect to the ADBA server. Check your connection.";
      if (err.response) {
        // Server responded with a status code outside 2xx
        const data = err.response.data;
        if (typeof data === "string") {
          errorMessage = data;
        } else if (data && typeof data === "object") {
          // Try common fields
          errorMessage = data.message || data.error || data.title || data.detail || JSON.stringify(data);
        }
        // Optionally, override with status-specific message if no data
        if (err.response.status === 401) {
          errorMessage = errorMessage === "Failed to connect..." ? "Invalid mobile number or password." : errorMessage;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-grid-bg" />

      <div className="login-card">
        <div className="login-header">
          <div className="login-logo" style={{ background: "transparent", boxShadow: "none" }}>
            <img src="/logo.png" alt="ADBA Logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          </div>
          <h2 className="login-title">PLAYER LOGIN</h2>
          <p className="login-subtitle">Access your digital ADBA card and standing portal</p>
        </div>

        <form onSubmit={handleLoginSubmit} className="login-form">
          {/* Mobile Number Field */}
          <div className="login-field">
            <label className="login-label" htmlFor="mobileNumber">Mobile Number</label>
            <div className="login-input-wrapper">
              <input
                type="tel"
                id="mobileNumber"
                value={mobileNumber}
                onChange={(e) => {
                  setMobileNumber(e.target.value);
                  if (error) setError("");
                }}
                className="login-input"
                placeholder="e.g. 9999999999"
                disabled={isLoading}
              />
              <span className="login-input-icon">
                <PhoneIcon />
              </span>
            </div>
          </div>

          {/* Password Field */}
          <div className="login-field">
            <label className="login-label" htmlFor="password">Password</label>
            <div className="login-input-wrapper">
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error) setError("");
                }}
                className="login-input"
                placeholder="••••••••"
                disabled={isLoading}
              />
              <span className="login-input-icon">
                <LockIcon />
              </span>
            </div>
          </div>

          {/* Error Message */}
          {error && (
            <div className="login-error-wrapper">
              <AlertCircleIcon />
              <span>{error}</span>
            </div>
          )}

          {/* Submit Button */}
          <button type="submit" className="login-btn-submit" disabled={isLoading}>
            {isLoading ? (
              <>
                <div className="login-loader" /> Logging in...
              </>
            ) : (
              "Sign In"
            )}
          </button>
        </form>

        <div className="login-footer-links">
          <Link to="/register" className="login-link">New Player? Register</Link>
          <Link to="/" className="login-link-gray">Return Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
